if (!customElements.get('rituals-variant-picker')) {
  customElements.define(
    'rituals-variant-picker',
    class RitualsVariantPicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onPillClick.bind(this));
      }

      onPillClick(event) {
        const pill = event.target.closest('.rituals-pill');
        if (!pill || pill.classList.contains('is-selected')) return;

        this.querySelectorAll('.rituals-pill').forEach((el) => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');

        const card = this.closest('.rituals-card');
        if (!card) return;

        const variantIdInput = card.querySelector('[data-variant-id-input]');
        if (variantIdInput) variantIdInput.value = pill.dataset.variantId;

        const priceEl = card.querySelector('[data-price-el]');
        if (priceEl) priceEl.textContent = pill.dataset.price;

        const available = pill.dataset.available === 'true';
        const addButton = card.querySelector('[data-add-to-cart-btn]');
        if (addButton) {
          addButton.disabled = !available;
          addButton.toggleAttribute('aria-disabled', !available);
          const label = addButton.querySelector('[data-add-to-cart-label]');
          if (label) {
            label.textContent = available
              ? label.dataset.addLabel
              : label.dataset.soldOutLabel;
          }
        }

        const image = card.querySelector('.rituals-card__image');
        if (image && pill.dataset.imageSrc) {
          image.src = pill.dataset.imageSrc;
          image.srcset = pill.dataset.imageSrcset;
          if (pill.dataset.imageAlt) image.alt = pill.dataset.imageAlt;
        }
      }
    }
  );
}
